import {
	initialStateObjectCollection,
	updateItemInStateItems,
	updateItemsInStateItems,
	makeStateSnapshot,
	restoreStateSnapshot,
} from "funkis-foundation/redux/utils/reducerUtils";

import {
	UPDATE_PAGES,
	UPDATE_PAGE,
	MAKE_PAGES_SNAPSHOT,
	RESTORE_FROM_PAGES_SNAPSHOT,
} from "../constants/ActionConstants";

const pages = (state = initialStateObjectCollection(), action) => {
	switch (action.type) {
		case UPDATE_PAGES:
			return updateItemsInStateItems(state, action.items);
		case UPDATE_PAGE:
			return updateItemInStateItems(state, action.item);
		case MAKE_PAGES_SNAPSHOT:
			return makeStateSnapshot(state, action.item);
		case RESTORE_FROM_PAGES_SNAPSHOT:
			return restoreStateSnapshot(state, action.item);
		default:
			return state;
	}
};

export default pages;
